export default __webpack_public_path__ + "static/LeetCode-ed03587afcc4efc475da3c13e2a9f4ee.svg";